// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"119":"5d52d76a10857b01","521":"79db42b3a50c6d98"}[chunkId] + ".js";
};